// @flow

import { type CardBrand } from '@tectonics/prs/card-brand';

// Card payment methods whose `fx_latency` key is the resolved card brand (e.g. `visa`),
// not the group method code.
const CARD_PAYMENT_METHODS: ImmutableArray<string> = ['creditcard', 'google', 'debitcard'];

// Resolves the `payment_type` code used as the key of the `fx_latency` node.
// For card methods the code is the detected brand; for every other method it is the
// selected method code itself. Returns `undefined` when a card brand is not yet known.
export function resolvePaymentTypeCode(selectedPaymentMethod: string, cardBrand: ?CardBrand): ?string {
  if (CARD_PAYMENT_METHODS.includes(selectedPaymentMethod)) {
    return cardBrand ?? undefined;
  }

  return selectedPaymentMethod;
}
